import { useMemo, useState } from 'react';

import useNotifications from '@/hooks/useNotifications';

import AppNavigationPage from '../../shared-components/wrappers/components/AppNavigationPage';

import AlertFrame from './components/alertframe';
import AlertHeader from './components/alertheader';
import AlertTab from './components/alerttab';

import './index.css';

export default function Notifications() {

  const [index, setIndex] = useState(1);
  const { queryData } = useNotifications();
  const notifications = useMemo(
    () => (Array.isArray(queryData?.data?.data) ? queryData.data.data : []),
    [queryData]
  );

  return (
    <>
      <AppNavigationPage>
        <div className="notification__page">
          <AlertHeader />
          <AlertTab index={index} setIndex={setIndex}/>
          {
            notifications.map((item, idx) => (
              (!index || index == (item.type ? 1 : 0) + 1) && <AlertFrame key={idx} value={item} />
            ))
          }
        </div>
      </AppNavigationPage>
    </>
  );
}
